<template>
    <div class="product-accessories" v-loading="loading">
        <transition name="fade" mode="out-in">
            <div v-if="addMode" key="addMode">
                <div class="row">
                    <div class="col-lg-8">
                        <el-input placeholder="Produit" v-model="q"></el-input>
                    </div>
                    <div class="col-lg-4">
                        <el-button type="primary" @click.prevent="search" plain>Rechercher</el-button>
                        <el-button type="default" @click.prevent="list" plain>Retour</el-button>
                        <el-button v-if="finded.length" type="default" @click.prevent="addAllProducts()" plain>Tous ajouter</el-button>
                    </div>
                </div>
                <el-table style="width: 100%" :data="finded" stripe>
                    <el-table-column prop="visuel" width="55">
                        <template slot-scope="scope">
                            <el-badge :value="scope.row.images.length" class="item">
                                <span class="avatar"  v-if="scope.row.image" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.image.path+'\')'}"></span>
                                <span class="avatar"  v-else-if="scope.row.images.length" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.images[0].path+'\')'}"></span>
                                <span class="avatar"  v-else></span>
                            </el-badge>
                        </template>
                    </el-table-column>
                    <el-table-column prop="shop_id" label="Ref Speedway / ID" >
                        <template slot-scope="scope">
                            {{ scope.row.shop_id }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="Titre"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.feature_type">[{{scope.row.feature_type}}] </span>{{ scope.row.name }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="external_ref" label="Ref fournisseur"  >
                        <template slot-scope="scope">
                            {{ scope.row.mf_prefixe }} / {{ scope.row.external_ref }}
                            <span v-if="scope.row.base_ref">
                                <br>
                                ({{ scope.row.base_ref }}<template v-if="scope.row.color_code"> / {{scope.row.color_code}}</template>)
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="actions" >
                        <template slot-scope="scope">
                            <el-button v-if="!inListAccessories(scope.row.id)" @click="addProduct(scope.row.id)" type="success" icon="el-icon-plus" size="mini"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else key="listMode">
                <div class="pull-right">
                    <button @click.prevent="add" class="btn btn-outline-primary">Ajouter un produit</button>
                </div>
                <div class="clearfix"></div>

                <div class='row-product headings'>
                    <span></span>
                    <span></span>
                    <span>Ref Speedway / ID</span>
                    <span>Titre</span>
                    <span>Ref fournisseur</span>
                    <span>Actions</span>
                </div>

                <draggable
                    v-model='accessories'
                    handle=".handle"
                    class='draggable-part'
                    @change='updateList'
                >
                    <div v-for='accessory in accessories' :key='accessory.id' class='row-product'>
                        <div>
                            <el-button type="" class="handle" >
                                <svg xmlns="http://www.w3.org/2000/svg" style="width:1.5em;height:1.5em;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
                                </svg>
                            </el-button>
                        </div>

                        <div>
                            <el-badge :value="accessory.images.length" class="item">
                                <span class="avatar"  v-if="accessory.image" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+accessory.image.path+'\')'}"></span>
                                <span class="avatar"  v-else-if="accessory.images.length" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+accessory.images[0].path+'\')'}"></span>
                                <span class="avatar"  v-else></span>
                            </el-badge>
                        </div>

                        <div>
                            {{ accessory.shop_id }}
                        </div>

                        <div>
                            <span v-if="accessory.feature_type">[{{accessory.feature_type}}] </span>{{ accessory.name }}
                        </div>

                        <div>
                            {{ accessory.mf_prefixe }} / {{ accessory.external_ref }}
                            <span v-if="accessory.base_ref">
                                <br>
                                ({{ accessory.base_ref }}<template v-if="accessory.color_code"> / {{accessory.color_code}}</template>)
                            </span>
                        </div>

                        <div>
                            <el-button  @click="removeProduct(accessory.id)" type="danger" icon="el-icon-delete" size="mini"></el-button>
                        </div>
                    </div>
                </draggable>
            </div>
        </transition>




    </div>
</template>
<script>
import Variation from '../../models/Variation';
import { EventBus } from '../../event-bus';
import draggable from 'vuedraggable';
export default {
    components: {
        draggable,
    },
    data() {
        return {
            loading: false,
            addMode: false,
            q: null,
            accessories: [],
            finded: []
        };
    },
    props: {
        product: {
            required: true
        }
    },
    computed: {
        productId() {
            return this.product.id;
        },
    },
    watch: {
        productId(newV, oldV) {
            if (!newV) return;
            this.refresh();
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.loading = true;
            this.fetch().then(() => {
                this.loading = false;
            });
        },
        fetch() {
            return axios
                .get('/products/' + this.productId + '/accessories')
                .then(r => {
                    this.accessories = r.data.data
                });

        },
        addAllProducts()
        {
            let filtred = this.finded.filter( v => !this.accessories.find( (vv) => vv.id == v.id ) );
            filtred.forEach((v)=>{
                this.addProduct(v.id)
            });
            this.list()
        },
        add() {
            this.finded = [];
            this.addMode = true;
            this.q = null;
        },
        list() {
            this.addMode = false;
        },
        addProduct(id)
        {
            axios.post('/products/' + this.productId + '/accessories', {products:[id]}).then(r=>{
                this.accessories = r.data.data
            })
        },
        updateList() {
            axios.put('/products/' + this.productId + '/accessories', {products:this.accessories.map(v=>v.id), mode:'update'}).then(r=>{
                this.accessories = r.data.data
            })
        },
        removeProduct(id)
        {
            this.$confirm('Voulez-vous supprimer le produit des recommandations', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    axios.put('/products/' + this.productId + '/accessories', {products:[id], mode:'delete'}).then(r=>{
                        this.accessories = r.data.data
                    })
                }).catch(()=>{

                })

        },
        inListAccessories(id)
        {
            return this.accessories.filter(v=>v.id == id).length
        },
        search()
        {
            var excluded = this.accessories.map(v => v.id);
            excluded.push(this.productId);
            var excludedString = excluded.join(',')
            var params = {
                exclude_products: excludedString,
                q: this.q,
                filterListShopId: true,
                filterListRef: true,
            }
            this.loading = true
            axios.get('/search', {params}).then(r => {
                this.finded = r.data.data
            }).catch(r=>{

            }).then(()=>{
                this.loading = false
            })
        },

    }
};
</script>
<style lang="scss">
.product-variations {
    .silent-link {
        &:hover {
            text-decoration: none;
        }
    }
    .placeholder-img {
        text-align: center;
        width: 120px;
        height: 90px;
        background: #e7e7e7;
        vertical-align: middle;
        display: table-cell;
        color: #007bfffc;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}

.draggable-part {
    .row-product:nth-child(odd) {
        background: #f7f7f7;
    }
}

.row-product {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 1rem;

    & > * {
        &:nth-child(n+4) {
            flex: 1;
        }

        &:not(:first-child) {
            margin-left: 10px;
        }
    }

    &.headings {
        font-weight: bold;
        border-bottom: 1px solid #e7e7e7;
    }
}
</style>
